/**
 * Sidebar Content Component
 * Combines header, navigation, and footer
 */

import { TooltipProvider } from '@ufc/uikit'
import type { SidebarContentProps } from '../types'
import { SidebarHeader } from './sidebar-header'
import { SidebarNav } from './sidebar-nav'
import { SidebarFooter } from './sidebar-footer'

export function SidebarContent({ collapsed = false, onNavigate }: SidebarContentProps) {
  return (
    <TooltipProvider delayDuration={0}>
      <div className="flex flex-col h-full">
        <SidebarHeader collapsed={collapsed} />
        <SidebarNav collapsed={collapsed} onNavigate={onNavigate} />
        <SidebarFooter collapsed={collapsed} onNavigate={onNavigate} />
      </div>
    </TooltipProvider>
  )
}
